import React, { useState } from "react";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import TooltipSubItems from "../common/TooltipSubItems";

interface IProps {
  id?: number;
  href?: string;
  icon?: React.ReactNode;
  icon2?: React.ReactNode;
  icon3?: React.ReactNode;
  title: string;
  drawer: boolean;
  subItems?: {
    id: number;
    href: string;
    title: string;
    icon?: React.ReactNode;
  }[];
  isOpen?: boolean;
  onClick?: () => void;
}

export const NavItem: React.FC<IProps> = ({
  id,
  href,
  icon,
  icon2,
  icon3,
  title,
  drawer,
  subItems,
  isOpen,
  onClick,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const active = href ? location.pathname === href : false;

  const gotoRoute = (href: string) => {
    navigate(href);
  };

  // const handleToggle = () => {
  //   setOpen((prevOpen) => !prevOpen);
  // };

  const listItemTextProps = {
    primaryTypographyProps: {
      sx: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: drawer ? "auto" : "100%",
        maxWidth: drawer ? "100%" : "inherit",
      },
    },
  };

  return (
    <>
      {drawer ? (
        <>
          <ListItemButton
            onClick={() => {
              onClick?.(); // always run this
              if (!subItems && href) gotoRoute(href); // if not parent, go to route
            }}
            key={title}
            sx={{
              px: 1.2,
              color: active ? "#FFFFFF" : undefined,
              bgcolor: active ? "#0055A8" : undefined,
              "&:hover": {
                cursor: "pointer",
                color: "#E52B50",
              },
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: drawer ? 3 : "auto",
              }}
            >
              {icon}
            </ListItemIcon>

            <ListItemText
              primary={title}
              sx={{ opacity: drawer ? 1 : 0 }}
              {...listItemTextProps}
            />
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: drawer ? 3 : "auto",
              }}
            >
              {isOpen ? icon2 : icon3}
            </ListItemIcon>
          </ListItemButton>
        </>
      ) : (
        <>
          <TooltipSubItems title={title} subItems={subItems}>
            <ListItemButton
              // onClick={subItems ? handleToggle : () => gotoRoute(href || "")}
              onClick={() => {
                onClick?.(); // always run this
                if (!subItems && href) gotoRoute(href); // if not parent, go to route
              }}
              key={title}
              sx={{
                px: 1.2,
                color: active ? "#FFFFFF" : "#333333",
                bgcolor: active ? "#0055A8" : undefined,
                "&:hover": {
                  cursor: "pointer",
                  color: "#E52B50",
                  justifyContent: "center",
                  alignItems: "center",
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: drawer ? 3 : "auto",
                }}
              >
                {icon}
              </ListItemIcon>

              <ListItemText
                primary={title}
                sx={{ opacity: drawer ? 1 : 0 }}
                {...listItemTextProps}
              />
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: drawer ? 3 : "auto",
                }}
              >
                {isOpen ? icon2 : icon3}
              </ListItemIcon>
            </ListItemButton>
          </TooltipSubItems>
        </>
      )}

      {subItems && (
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          {subItems.map((subItem) => {
            const subItemActive = location.pathname === subItem.href;

            const subItemButton = (
              <ListItemButton
                key={subItem.id}
                onClick={() => {
                  gotoRoute(subItem.href);
                }}
                sx={{
                  pl: 2,
                  color: subItemActive ? "#FFFFFF" : undefined,
                  bgcolor: subItemActive ? "#0055A8" : undefined,
                  "&:hover": {
                    cursor: "pointer",
                    color: "#FFFFFF",
                    bgcolor: "darkslateblue",
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: 32 }}>
                  {subItem.icon}
                </ListItemIcon>
                <ListItemText
                  primary={subItem.title}
                  sx={{ opacity: drawer ? 1 : 0 }}
                  {...listItemTextProps}
                />
              </ListItemButton>
            );

            return drawer ? (
              subItemButton
            ) : (
              <TooltipSubItems
                key={subItem.id}
                title={subItem.title}
                subItems={[]}
              >
                {subItemButton}
              </TooltipSubItems>
            );
          })}
        </Collapse>
      )}
    </>
  );
};
